import {
    GET_CURRENT_SOFTWARE
} from './constants';

const initialState = {
    currentSoftware: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_SOFTWARE: {
            return {
                ...state,
                currentSoftware: action.payload,
            };
        }
        default:
            return state;
    }
};

